module.exports = __webpack_public_path__ + "img/logo-header.abdba73b.png";